import { Link, useLocation } from 'react-router-dom';
import useWindowSize from '../hooks/useWindowSize';

/**
 * Componente de navegación del tutor
 * Se muestra en todas las páginas cuando el usuario está logueado
 */
const TutorNavigation = () => {
  const location = useLocation();
  const { width, isMobile } = useWindowSize();

  // Detectar pantallas muy pequeñas (solo cuando realmente no caben las palabras)
  const isVerySmall = width <= 360;

  // Función para verificar si una ruta está activa
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div style={{
      width: '100%',
      borderBottom: '1px solid #e1e5e9',
      backgroundColor: '#ffffff',
      position: 'relative',
      zIndex: 10,
      marginBottom: isMobile ? '16px' : '32px',
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: isVerySmall ? '6px 8px' : isMobile ? '8px 16px' : '20px 24px',
      }}>
        <nav style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: isVerySmall ? '4px' : isMobile ? '6px' : '16px',
          justifyContent: isMobile ? 'center' : 'flex-start',
          alignItems: 'center',
        }}>
        <Link
          to="/profile"
          style={{
            color: isActive('/profile') ? '#FF8C00' : '#495057',
            textDecoration: 'none',
            fontSize: isVerySmall ? '10px' : isMobile ? '11px' : '14px',
            fontWeight: isActive('/profile') ? '600' : '500',
            padding: isVerySmall ? '3px 4px' : isMobile ? '4px 6px' : '10px 16px',
            borderRadius: '4px',
            backgroundColor: isActive('/profile') ? 'rgba(255, 140, 0, 0.1)' : 'transparent',
            border: isActive('/profile') ? '1px solid #FF8C00' : '1px solid #e1e5e9',
            transition: 'all 0.3s ease',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            gap: isVerySmall ? '2px' : isMobile ? '3px' : '6px',
            flex: isMobile ? '0 1 auto' : 'none',
            minWidth: isMobile ? 'auto' : 'auto',
          }}
          onMouseOver={(e) => {
            if (!isActive('/profile')) {
              e.target.style.color = '#FF8C00';
              e.target.style.backgroundColor = 'rgba(255, 140, 0, 0.05)';
              e.target.style.borderColor = '#FF8C00';
            }
          }}
          onMouseOut={(e) => {
            if (!isActive('/profile')) {
              e.target.style.color = '#495057';
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#e1e5e9';
            }
          }}
        >
          <span className="material-icons" style={{ fontSize: isVerySmall ? '10px' : isMobile ? '12px' : '16px' }}>
            person
          </span>
          {isVerySmall ? 'P' : 'Mi Perfil'}
        </Link>

        <Link
          to="/wallet"
          style={{
            color: isActive('/wallet') ? '#FF8C00' : '#495057',
            textDecoration: 'none',
            fontSize: isVerySmall ? '10px' : isMobile ? '11px' : '14px',
            fontWeight: isActive('/wallet') ? '600' : '500',
            padding: isVerySmall ? '3px 4px' : isMobile ? '4px 6px' : '10px 16px',
            borderRadius: '4px',
            backgroundColor: isActive('/wallet') ? 'rgba(255, 140, 0, 0.1)' : 'transparent',
            border: isActive('/wallet') ? '1px solid #FF8C00' : '1px solid #e1e5e9',
            transition: 'all 0.3s ease',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            gap: isVerySmall ? '2px' : isMobile ? '3px' : '6px',
            flex: isMobile ? '0 1 auto' : 'none',
            minWidth: isMobile ? 'auto' : 'auto',
          }}
          onMouseOver={(e) => {
            if (!isActive('/wallet')) {
              e.target.style.color = '#FF8C00';
              e.target.style.backgroundColor = 'rgba(255, 140, 0, 0.05)';
              e.target.style.borderColor = '#FF8C00';
            }
          }}
          onMouseOut={(e) => {
            if (!isActive('/wallet')) {
              e.target.style.color = '#495057';
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#e1e5e9';
            }
          }}
        >
          <span className="material-icons" style={{ fontSize: isVerySmall ? '10px' : isMobile ? '12px' : '16px' }}>
            shopping_bag
          </span>
          {isVerySmall ? 'C' : 'Compras'}
        </Link>

        <Link
          to="/tutor"
          style={{
            color: isActive('/tutor') ? '#FF8C00' : '#495057',
            textDecoration: 'none',
            fontSize: isVerySmall ? '10px' : isMobile ? '11px' : '14px',
            fontWeight: isActive('/tutor') ? '600' : '500',
            padding: isVerySmall ? '3px 4px' : isMobile ? '4px 6px' : '10px 16px',
            borderRadius: '4px',
            backgroundColor: isActive('/tutor') ? 'rgba(255, 140, 0, 0.1)' : 'transparent',
            border: isActive('/tutor') ? '1px solid #FF8C00' : '1px solid #e1e5e9',
            transition: 'all 0.3s ease',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            gap: isVerySmall ? '2px' : isMobile ? '3px' : '6px',
            flex: isMobile ? '0 1 auto' : 'none',
            minWidth: isMobile ? 'auto' : 'auto',
          }}
          onMouseOver={(e) => {
            if (!isActive('/tutor')) {
              e.target.style.color = '#FF8C00';
              e.target.style.backgroundColor = 'rgba(255, 140, 0, 0.05)';
              e.target.style.borderColor = '#FF8C00';
            }
          }}
          onMouseOut={(e) => {
            if (!isActive('/tutor')) {
              e.target.style.color = '#495057';
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#e1e5e9';
            }
          }}
        >
          <span className="material-icons" style={{ fontSize: isVerySmall ? '10px' : isMobile ? '12px' : '16px' }}>
            sports_soccer
          </span>
          {isVerySmall ? 'J' : 'Mis Futbolistas'}
        </Link>

        <Link
          to="/notifications"
          style={{
            color: isActive('/notifications') ? '#FF8C00' : '#495057',
            textDecoration: 'none',
            fontSize: isVerySmall ? '10px' : isMobile ? '11px' : '14px',
            fontWeight: isActive('/notifications') ? '600' : '500',
            padding: isVerySmall ? '3px 4px' : isMobile ? '4px 6px' : '10px 16px',
            borderRadius: '4px',
            backgroundColor: isActive('/notifications') ? 'rgba(255, 140, 0, 0.1)' : 'transparent',
            border: isActive('/notifications') ? '1px solid #FF8C00' : '1px solid #e1e5e9',
            transition: 'all 0.3s ease',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            gap: isVerySmall ? '2px' : isMobile ? '3px' : '6px',
            flex: isMobile ? '0 1 auto' : 'none',
            minWidth: isMobile ? 'auto' : 'auto',
          }}
          onMouseOver={(e) => {
            if (!isActive('/notifications')) {
              e.target.style.color = '#FF8C00';
              e.target.style.backgroundColor = 'rgba(255, 140, 0, 0.05)';
              e.target.style.borderColor = '#FF8C00';
            }
          }}
          onMouseOut={(e) => {
            if (!isActive('/notifications')) {
              e.target.style.color = '#495057';
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#e1e5e9';
            }
          }}
        >
          <span className="material-icons" style={{ fontSize: isVerySmall ? '10px' : isMobile ? '12px' : '16px' }}>
            notifications
          </span>
          {isVerySmall ? 'A' : 'Notificaciones'}
        </Link>

        <Link
          to="/help"
          style={{
            color: isActive('/help') ? '#FF8C00' : '#495057',
            textDecoration: 'none',
            fontSize: isVerySmall ? '10px' : isMobile ? '11px' : '14px',
            fontWeight: isActive('/help') ? '600' : '500',
            padding: isVerySmall ? '3px 4px' : isMobile ? '4px 6px' : '10px 16px',
            borderRadius: '4px',
            backgroundColor: isActive('/help') ? 'rgba(255, 140, 0, 0.1)' : 'transparent',
            border: isActive('/help') ? '1px solid #FF8C00' : '1px solid #e1e5e9',
            transition: 'all 0.3s ease',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            gap: isVerySmall ? '2px' : isMobile ? '3px' : '6px',
            flex: isMobile ? '0 1 auto' : 'none',
            minWidth: isMobile ? 'auto' : 'auto',
          }}
          onMouseOver={(e) => {
            if (!isActive('/help')) {
              e.target.style.color = '#FF8C00';
              e.target.style.backgroundColor = 'rgba(255, 140, 0, 0.05)';
              e.target.style.borderColor = '#FF8C00';
            }
          }}
          onMouseOut={(e) => {
            if (!isActive('/help')) {
              e.target.style.color = '#495057';
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#e1e5e9';
            }
          }}
        >
          <span className="material-icons" style={{ fontSize: isVerySmall ? '10px' : isMobile ? '12px' : '16px' }}>
            help
          </span>
          {isVerySmall ? '?' : 'Ayuda'}
        </Link>
        </nav>
      </div>
    </div>
  );
};

export default TutorNavigation;
